<div class="card-body">
    <canvas height="100px" id="basic_line_chart"></canvas>
</div>